import ACTION_TYPES from "../actions/type.action";

const initialState = {
    hierarchy: [],
    scores: []
};

const reducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case ACTION_TYPES.UPDATE_KNOWLEDGE_REPORT:
            const { hierarchy, scores } = payload;
            return {
                ...state,
                hierarchy,
                scores,
            };



        default:
            return state;
    }
};

export default reducer;
